import Phaser from "phaser";

export default class AnswerFeedBack extends Phaser.GameObjects.Container {
  constructor(
    scene,
    x,
    y,
    imageKey = "bonne-rep-activite-1",
    text = "Bravo !"
  ) {
    super(scene, x, y);

    // Add circle image as background
    this.bg = scene.add.image(0, 0, imageKey);
    this.bg.setOrigin(0.5, 0.5);

    // Add centered text
    this.txt = scene.add.text(0, 0, text, {
      fontFamily: "Binx",
      fontSize: `${24 * 1.5}px`,
      color: "#FFFFFF",
      align: "center",
      wordWrap: { width: 300, useAdvancedWrap: true },
    });
    this.txt.setAngle(-15);
    this.txt.setOrigin(0.5, 0.5);

    this.add(this.bg);
    this.add(this.txt);

    scene.add.existing(this);
  }
}
